import qs from 'qs'
import { SearchParams } from '@/types'
import {
  FlowValveType,
  FormFlowValve,
  InputValveOptions,
} from '@/types/hydraulic'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'
import { OutputDecoderType } from '@/types/decoder'

const flowValveApi = {
  getAll(searchParams: SearchParams) {
    const url = '/api/flowvalve'
    return axiosClient.get(url + queryStringify(searchParams))
  },

  getFlowValveError(searchParams: SearchParams) {
    const url = '/api/flowvalve/error'
    return axiosClient.get(url + queryStringify(searchParams))
  },

  getById(interfaceId: number, id: number): Promise<{ data: FlowValveType }> {
    const url = `/api/flowvalve/${interfaceId}/${id}`
    return axiosClient.get(url)
  },

  create(payload: FormFlowValve) {
    const url = '/api/flowvalve'
    return axiosClient.post(url, payload)
  },

  resetError(interfaceId: number) {
    const url = `/api/flowvalve/reset-errors?interfaceId=${interfaceId}`
    return axiosClient.post(url)
  },

  resetErrorById(interfaceId: number, id: number) {
    const url = `/api/flowvalve/reset-error-by-id?interfaceId=${interfaceId}&id=${id}`
    return axiosClient.post(url)
  },

  delete(interfaceId: string, id: string) {
    const url = `/api/flowvalve/?interfaceId=${interfaceId}&id=${id}`
    return axiosClient.delete(url)
  },

  update(payload: FormFlowValve) {
    const url = '/api/flowvalve'
    return axiosClient.put(url, payload)
  },
  getDetailIO(interfaceId: number, Purpose?: OutputDecoderType[]): Promise<{ data: InputValveOptions[] }> {
    const url = `/api/Controller/${interfaceId}/get-details`
    return axiosClient.get(url, {
      params: {
        Purpose, 
      },
      paramsSerializer: params =>
        qs.stringify(params, { arrayFormat: "repeat" }
      )
    })
  },
}

export default flowValveApi
